
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Activity, Search, MousePointer, TrendingUp } from "lucide-react";

interface AnalyticsCardsProps {
  stats: {
    uniqueSessions: number;
    totalInteractions: number;
    searches: number;
    clicks: number;
    clickThroughRate: string;
  } | undefined;
}

export const AnalyticsCards = ({ stats }: AnalyticsCardsProps) => {
  if (!stats) return null;

  const cards = [
    {
      title: "Unieke Bezoekers",
      value: stats.uniqueSessions,
      icon: Users,
      description: "Vandaag",
      color: "text-blue-600"
    },
    {
      title: "Totaal Interacties",
      value: stats.totalInteractions,
      icon: Activity,
      description: "Alle acties",
      color: "text-green-600"
    },
    {
      title: "Zoekopdrachten",
      value: stats.searches,
      icon: Search,
      description: "Uitgevoerd",
      color: "text-purple-600"
    },
    {
      title: "Clicks",
      value: stats.clicks,
      icon: MousePointer,
      description: "Op resultaten",
      color: "text-orange-600"
    },
    {
      title: "CTR",
      value: `${stats.clickThroughRate}%`,
      icon: TrendingUp,
      description: "Click-through rate",
      color: "text-indigo-600"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index} className="hover:shadow-lg transition-shadow">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {card.title}
              </CardTitle>
              <Icon className={`h-4 w-4 ${card.color}`} />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{card.value}</div>
              <p className="text-xs text-muted-foreground">{card.description}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
